module.exports = __webpack_public_path__ + "static/media/compartir.31327fea.svg";